<div class="groupInvite-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="subheader" [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-content">
      <div class="group-invites">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-plus"></div>
        </div>
        <div class="group-invite-content">
          <div class="group-invite-info-item">
            <h2 class="title" langkey="phGroupOrder_Share_Title"></h2>
            <p>
              <span class="text desc content-container--subfont" langkey="phGroupOrder_Share_SubText"></span>
            </p>
            <p>
              <span class="text  content-container--subfont" langkey="phGroupOrder_Share_Link_Info"></span>
            </p>
          </div>
        </div>
        <div class="botton-wrapper">
          <div class="ya-webshop-button-container">
            <ng-container *ngIf="groupIsFull$| async; let groupIsFull; then deactiveButton else activeButton">
            </ng-container>
            <ng-template #deactiveButton>
              <span (click)="OpenWarningGroupIsFull()">
                <button mat-flat-button disabled><span langkey="phGroupOrder_Share_Link_Btn"></span></button>
              </span>
            </ng-template>
            <ng-template #activeButton>
              <button mat-flat-button (click)="ShareLink()"><span langkey="phGroupOrder_Share_Link_Btn"></span></button>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="group-qr">
        <div class="group-invite-info-item qrcode-header">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-qr"></div>
          </div>
          <h2 class="title" langkey="phGroupOrder_Invite_QRCode_Title"></h2>
        </div>
        <div class="group-invite-info-item">
          <p>
            <span class="text content-container--subfont" langkey="phGroupOrder_Invite_QRCode_Info"></span>
          </p>
        </div>
        <div class="botton-wrapper">
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="OpenQRCodeDialog()"><span langkey="phGroupOrder_Invite_Btn"></span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="shownavigatetomenu" class="group-navigatetomenu">
        <div class="botton-wrapper">
          <div class="ya-webshop-button-container">
            <button mat-flat-button class="navigate-to-menu-button" [class.active]="InviteAFriend"
              (click)="NavigateToMenu()">
              <span *ngIf="InviteAFriend; else InviteBtn" langkey="phGroupOrder_GroupCreated_Without_Invite_Btn"></span>
              <ng-template #InviteBtn>
                <span langkey="phGroupOrder_InviteFriends_Dialog_OrderNowBtn"></span>
              </ng-template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>